module.exports = __webpack_public_path__ + "Icono_Mas_512px.png";